import { useState, useCallback, useMemo, useEffect } from "react";
import { useParams } from "react-router";

import { MessageItem } from "models/inbox/inbox";
import { useGlobalContext } from "app/store/GlobalContext";
import MessageSidebarItem from "views/inbox/components/Inbox/sidebar/messageSidebarItem";
import NoMessagesToShowInfoText from "./noMessagesToShowInfoText/noMessagesToShowInfoText";

import "../index.scss";

type Props = {
  messages: MessageItem[];
};

export default function MessageSidebarList({ messages }: Props) {
  const { handleNavigation } = useGlobalContext();

  const { messageId: currentMessageId } = useParams();

  const [activeMessageId, setActiveMessageId] = useState<string>("");

  useEffect(() => {
    if (currentMessageId) {
      setActiveMessageId(`messages/${currentMessageId}`);
    } else {
      setActiveMessageId("");
    }
  }, [currentMessageId]);

  const sortMessages = useMemo(() => {
    return [...(messages ?? [])].sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }, [messages]);

  const handleOnSelect = useCallback(
    (messageId: string, e) => {
      handleNavigation({
        url: `/inbox/sent/${messageId}`,
        eventTitle: "Message",
        e: e
      });
    },
    [handleNavigation]
  );

  if (!messages?.length) {
    return <NoMessagesToShowInfoText />;
  }

  return (
    <>
      {sortMessages.map((msg) => {
        const { messageId } = msg;
        return (
          <MessageSidebarItem
            key={messageId}
            message={msg}
            isActive={activeMessageId === messageId}
            onSelect={(e) => handleOnSelect(messageId, e)}
          />
        );
      })}
    </>
  );
}
